import { Radio, RadioChangeEvent } from "antd";
import { useCallback, useMemo } from "react";
import { IOption } from "../../../../../../../../../types/Option";
import { IPrintRequest } from "../../../types";

type YearsFormItemProps = {
  years: number[];
  isLoading: boolean;
  request: IPrintRequest;
  setRequest: React.Dispatch<React.SetStateAction<IPrintRequest>>;
};

export const YearsFormItem = ({
  years,
  isLoading,
  request,
  setRequest,
}: YearsFormItemProps) => {
  const options: IOption[] = useMemo(
    () =>
      years.map((year: number) => ({
        value: year,
        label: year.toString(),
      })),
    [years],
  );

  const onChange = useCallback(
    (e: RadioChangeEvent) => {
      setRequest((prev: IPrintRequest) => ({
        ...prev,
        year: e.target.value,
      }));
    },
    [setRequest],
  );

  return (
    <Radio.Group
      options={options}
      className="d-flex flex-column w-100"
      value={request.year}
      disabled={isLoading}
      onChange={onChange}
    />
  );
};
